// "use client";

// import { Image } from "@heroui/image";
// import { Spinner } from "@heroui/spinner";
// import { usePathname, useRouter } from "next/navigation";
// import { useEffect } from "react";
// import { Icon } from "@iconify/react";

// import { BlogServices } from "@/services";
// import { AllBlogs } from "@/types";
// import { useIsMobileOrTablet } from "@/app/custom-hook/useIsMobileOrTablet";

// const BlogSection = () => {
//     const {
//         data: allBlogs,
//         isLoading: blogLoading,
//         refetch: refetchBlog,
//     } = BlogServices().useGetAllBlog({});
//     const { data: categories } = BlogServices().useGetAllBlogCategory();
//     const router = useRouter();
//     const currentPath = usePathname();

//     const viewBlog = (blog_id: string) => {
//         router.push(`/blog/${blog_id}`);
//     };

//     useEffect(() => {
//         refetchBlog();
//     }, [currentPath]);
//     const isMobileOrTablet = useIsMobileOrTablet();

//     return (
//         <section className="lg:px-28 px-6  max-w-screen-2xl mx-auto py-[50px] md:py-[75px] px-4 md:px-0">
//             <div
//                 className="flex justify-between items-center mb-6 md:mb-10 gap-4"
//                 data-aos="fade-up"
//             >
//                 <div>
// <p className="text-xs text-green-600 mb-1 font-medium leading-4">
//     Blog
// </p>

//                     <h2 className="text-xl leading-7 md:text-2xl md:leading-8 font-medium text-foreground">
//                         Latest news from us
//                     </h2>
//                 </div>

//                 <button
//                     className="text-sm md:text-base text-neutral-950 cursor-pointer flex items-center font-normal leading-6 tracking-[-0.176px] gap-2 hover:gap-4 transition-all shrink-0"
//                     onClick={() => router.push("/blog")}
//                 >
//                     Read more <Icon icon="ri:arrow-right-s-line" />
//                 </button>
//             </div>

//             {/* Cards */}
//             {!blogLoading ? (
//                 <div
//                     className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8"
//                     data-aos="fade-up"
//                     data-aos-delay="100"
//                 >
//                     {allBlogs?.data
//                         ?.slice(
//                             isMobileOrTablet ? (allBlogs?.data?.length >= 4 ? -4 : -2) : -3,
//                         )
//                         .map((blog: AllBlogs, index: number) => (
//                             <button
//                                 key={index}
//                                 className="group text-left cursor-pointer"
//                                 data-aos="fade-up"
//                                 data-aos-delay={index * 100}
//                                 onClick={() => viewBlog(blog.slug as string)}
//                             >
//                                 {/* Image */}
//                                 <div className="relative w-full h-[200px] md:h-[237px] rounded-2xl overflow-hidden  mb-[10px] md:mb-[13px]">
//                                     <Image
//                                         removeWrapper
//                                         alt="blog image"
//                                         className="object-cover w-full h-full object-top md:rounded-4xl"
//                                         src={blog.featuredImage}
//                                     />
//                                 </div>

//                                 {/* Content */}
//                                 <div>
//                                     <p className="text-sm md:text-sm font-medium text-neutral-950 leading-relaxed">
//                                         {blog?.title.length > 30
//                                             ? blog?.title.slice(0, 30) + "..."
//                                             : blog?.title}
//                                     </p>

//                                     <p className="text-xs md:text-xs text-neutral-500 leading-relaxed mb-2 md:mb-3">
//                                         {blog?.description.length > 130
//                                             ? blog?.description.slice(0, 130) + "..."
//                                             : blog?.description}
//                                     </p>

//                                     <div className="flex items-center gap-2 text-xs text-neutral-500">
//                                         <span className="uppercase tracking-[0.48px] leading-4">
//                                             {categories?.find(
//                                                 (cat: { _id: string }) => cat._id === blog.category,
//                                             )?.name ?? "—"}
//                                         </span>

//                                         <Icon
//                                             className="text-neutral-200 text-2xl md:text-3xl"
//                                             icon="bi:dot"
//                                         />

//                                         <span>
//                                             {new Date(blog?.createdAt as string).toDateString()}
//                                         </span>
//                                     </div>
//                                 </div>
//                             </button>
//                         ))}
//                 </div>
//             ) : (
//                 <div className="h-[200px] flex items-center justify-center">
//                     <Spinner />
//                 </div>
//             )}
//         </section>
//     );
// };

// export default BlogSection;

"use client";

import React, { useEffect } from "react";
import { Icon } from "@iconify/react";
import { Spinner } from "@heroui/spinner";
import { usePathname, useRouter } from "next/navigation";
import { motion } from "framer-motion";

import { BlogServices } from "@/services";
import { AllBlogs } from "@/types";
import { useIsMobileOrTablet } from "@/app/custom-hook/useIsMobileOrTablet";
import { BlogCard } from "@/components";

const BlogSection = () => {
  const {
    data: allBlogs,
    isLoading: blogLoading,
    refetch: refetchBlog,
  } = BlogServices().useGetAllBlog({});

  const router = useRouter();
  const currentPath = usePathname();
  const isMobileOrTablet = useIsMobileOrTablet();

  useEffect(() => {
    refetchBlog();
  }, [currentPath]);

  return (
    <section className="lg:px-28 px-6 max-w-screen-2xl mx-auto py-[50px] md:py-[75px]">
      {/* heading */}
      <motion.div
        className="flex justify-between items-center mb-8 md:mb-12 gap-4"
        initial={{ opacity: 0, y: 26 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
        whileInView={{ opacity: 1, y: 0 }}
      >
        <div>
          <p className="text-xs text-green-600 mb-1 font-medium leading-4">
            Blog
          </p>

          <h2 className="text-xl leading-7 md:text-2xl md:leading-8 font-medium text-foreground">
            Latest news from us
          </h2>
        </div>

        <button
          className="
            group
            flex items-center gap-2
            text-sm md:text-base
            font-medium
            text-primary
            transition-all duration-300
          "
          onClick={() => router.push("/blog")}
        >
          Read more
          <motion.div transition={{ duration: 0.2 }} whileHover={{ x: 3 }}>
            <Icon className="text-lg" icon="lucide:arrow-right" />
          </motion.div>
        </button>
      </motion.div>

      {/* cards */}
      {!blogLoading ? (
        <div
          className="
            grid
            grid-cols-1
            md:grid-cols-2
            lg:grid-cols-3
            gap-6 lg:gap-8
          "
        >
          {allBlogs?.data
            ?.slice(
              isMobileOrTablet ? (allBlogs?.data?.length >= 4 ? -4 : -2) : -3,
            )
            .map((blog: AllBlogs, index: number) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                transition={{
                  duration: 0.45,
                  delay: index * 0.08,
                }}
                viewport={{ once: true }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                <BlogCard data={blog} />
              </motion.div>
            ))}
        </div>
      ) : (
        <div className="h-[220px] flex items-center justify-center">
          <Spinner />
        </div>
      )}
    </section>
  );
};

export default BlogSection;
